
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'document-browser-tab',
    components: {},
    emits: ['close', 'iframeCreated', 'closeIframe', 'documentSaved'],
    props: { item: { type: Object }, functionalityId: { type: String } },
    data() {
        return {
            parameterValuesMap: {} as any,
            loadedItem: null as any
        }
    },
    computed: {
        key(): string {
            return this.item?.routerId
        }
    },
    watch: {
        item() {
            this.loadItem()
        }
    },
    created() {
        this.loadItem()
    },
    methods: {
        onIframeCreated(payload: any) {
            this.$emit('iframeCreated', payload)
        },
        onParametersChange(payload: any) {
            this.parameterValuesMap[payload.document.label + '-' + this.key] = payload.parameters
        },
        loadItem() {
            this.loadedItem = this.item
        }
    }
})
